<template>
  <component-wrapper>
    <grid-container-fi
      :class="{
        'image-text-tiles-fi': true,
        'image-text-tiles-fi--dark': isDark,
      }"
    >
      <div class="image-text-tiles-fi__tiles fi-col-span-12 xl:fi-col-span-8 xl:fi-col-start-3">
        <headline-fi
          v-if="(isEditMode && fields.headline) || fields.headline?.value"
          tag="h3"
          class="image-text-tiles-fi__tile image-text-tiles-fi__tile--headline"
          :size="36"
          :html-content="isEditMode ? fields.headline.editable : fields.headline?.value"
        />
      </div>
      <div class="image-text-tiles-fi__tiles fi-col-span-12 xl:fi-col-span-8 xl:fi-col-start-3">
        <div
          v-for="(tile, idx) in fields.imageTextTileElements"
          :key="idx"
          class="image-text-tiles-fi__tile"
        >
          <image-text-tile-fi
            :fields="tile.fields"
            :dark="!isDark"
          />
        </div>
        <div
          v-if="isEditMode && fields.imageTextTileElements?.length === 0"
          class="fi-col-span-12"
        >
          no content
        </div>
      </div>
    </grid-container-fi>
  </component-wrapper>
</template>

<script>
import { HeadlineFi } from 'atoms';
import ComponentWrapper from 'components/component-wrapper/ComponentWrapper';
import GridContainerFi from 'components/grid-fi/GridContainerFi';
import ImageTextTileFi from 'components/image-text-tile-fi/ImageTextTileFi';
import ssrOnlyMixin from 'mixins/ssrOnlyMixin';

export default {
  name: 'ImageTextTilesFi',
  components: {
    ComponentWrapper,
    GridContainerFi,
    ImageTextTileFi,
    HeadlineFi,
  },
  mixins: [ssrOnlyMixin],
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isDark() {
      return Boolean(this.fields?.dark?.value);
    },
  },
};
</script>

<style lang="scss">
@import './image-text-tiles-fi-unscoped';
</style>
